import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Resources from "@/pages/Resources";
import Favorites from "@/pages/Favorites";
import HowTo from "@/pages/HowTo";
import Feedback from "@/pages/Feedback";
import SupportServices from "@/pages/SupportServices";
import Pathways from "@/pages/Pathways";
import ChatBot from "@/components/ChatBot";

function App() {
  return (
    <FavoritesProvider>
      <div className="App min-h-screen bg-white">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/support-services" element={<SupportServices />} />
              <Route path="/pathways" element={<Pathways />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/how-to" element={<HowTo />} />
              <Route path="/feedback" element={<Feedback />} />
            </Routes>
          </main>
          <ChatBot />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </FavoritesProvider>
  );
}

export default App;
